import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { FormControl, IconButton } from '@material-ui/core';
import { ITenant } from 'interfaces/tenant';
import FormHelperText from '@material-ui/core/FormHelperText';
import { MutationsStatic } from 'graphql/mutations-static';
import { GraphQLHelper } from 'utilities/graphql-helper';
import EchoDialog from './EchoDialog';
import { CrossTenantReceivingAppModel } from 'models/app/cross-tenant-receiving-app';

interface Props {
  onAdd: () => void,
  onCancel: () => void,
  tenant: ITenant
}

const XTenantReceivingAppAdd: React.FC<Props> = (props) => {

  const [appName, setAppName] = useState('');
  const [sendingTenant, setSendingTenant] = useState('');
  const [appValid, setAppValid] = useState(false);
  const [infoMessage, setInfoMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [sendingTenantValid, setSendingTenantValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleAddApp = async () => {
    if (appValid && sendingTenantValid) {
      try {
        setIsLoading(true);
        setInfoMessage('');
        setErrorMessage('');
        setSuccessMessage('');
        const params = {
          tenant: props.tenant.name,
          name: appName,
          sendingTenant: sendingTenant,
        }
        const p = await GraphQLHelper.execute<CrossTenantReceivingAppModel>(MutationsStatic.createCrossTenantReceivingApp, params, CrossTenantReceivingAppModel);
        if (!p.error) {
          setSuccessMessage(`Cross-Tenant Receiving app ${appName} created.`);
        } else {
          setErrorMessage(p.errorMessage);
        }
      } catch (err) {
        setErrorMessage(JSON.stringify(err));
        console.log(JSON.stringify(err));
        console.log('Can\'t create XTenant Receiving app', err);
      } finally {
        setIsLoading(false);
      }
    }
  }

  const handleAppNameChange = (event: any) => {
    setAppName(event.target.value);
    setAppValid(event.target.value.match(/^[A-Za-z0-9\-_\.: ]{3,80}$/));
  }

  const handleSendingTenantChange = (event: any) => {
    setSendingTenant(event.target.value);
    setSendingTenantValid(event.target.value.length > 4);
  }

  const onShowHelp = () => {
    window.open('https://docs.echo.stream/docs/cross-tenant-app', '_blank');
  }

  const isDisabled = () : boolean => {
    return (successMessage && successMessage.length > 0 ? true : false);
  }

  return (
    <EchoDialog
      onCancel={props.onCancel}
      onOk={props.onAdd}
      onSave={async () => { await handleAddApp(); }}
      isValid={appValid && sendingTenantValid}
      errorMessage={errorMessage}
      infoMessage={infoMessage}
      successMessage={successMessage}
      title={
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div>Add Cross-Tenant Receiving Application</div>
          <div style={{ marginLeft: 'auto' }}>
            <IconButton onClick={() => { onShowHelp(); }}>
              <HelpOutlineIcon />
            </IconButton>
          </div>
        </div>}
      contentText="Add a tenant to receive the messages."
      open={true}
      spinner={isLoading}
    >
      <TextField
        error={!appValid}
        helperText="Name must be atleast 3 characters in length and may contain special characters (- _ . or :) ."
        variant="outlined"
        required
        autoFocus
        margin="dense"
        id="appName"
        label="Application name"
        fullWidth
        onChange={handleAppNameChange}
        disabled={(successMessage && successMessage.length > 0 ? true : false) || isLoading}
      />
      <div style={{ marginTop: '10px' }}>
        <FormControl variant="filled" style={{ width: '300px' }} >
          <TextField
            variant="outlined"
            margin="dense"
            id="sending_tenant"
            label="Sending Tenant"
            fullWidth
            onChange={handleSendingTenantChange}
            disabled={isDisabled()}
            />
          {!sendingTenantValid && <FormHelperText>Sending tenant Required!</FormHelperText>}
        </FormControl>
      </div>
    </EchoDialog>
  );
}

export default XTenantReceivingAppAdd;